export default "__VITE_ASSET__yRcAbeQR__"